import { TitleCasePipe } from '@angular/common';
import { Component, OnDestroy, OnInit, WritableSignal, inject } from '@angular/core';
import { SvgIconComponent, SvgIconRegistryService } from 'angular-svg-icon';
import { Subject, takeUntil } from 'rxjs';
import { ProgressTrackerStatus } from '../../models/enums/progress-tracker-status.enum';
import { WorkflowSection } from '../../models/workflow/workflow-section.model';
import { ProgressTrackerService } from './progress-tracker.service';

@Component({
  selector: 'seth-progress-tracker',
  standalone: true,
  imports: [SvgIconComponent, TitleCasePipe],
  templateUrl: './progress-tracker.component.html',
  styleUrl: './progress-tracker.component.scss',
})
export class ProgressTrackerComponent implements OnInit, OnDestroy {
  private _progressTrackerService: ProgressTrackerService = inject(ProgressTrackerService);
  status = ProgressTrackerStatus;
  showProgressTracker$: WritableSignal<boolean> = this._progressTrackerService.showProgressTracker();
  workflowSections$: WritableSignal<WorkflowSection[]> = this._progressTrackerService.getWorkflowSections();
  svgRegistry: SvgIconRegistryService = inject(SvgIconRegistryService);
  destroy$: Subject<boolean> = new Subject<boolean>();

  ngOnInit(): void {
    this.svgRegistry.loadSvg("../../assets/img/completed.svg", "completed")?.pipe(takeUntil(this.destroy$)).subscribe();
    this.svgRegistry.loadSvg("../../assets/img/in-progress.svg", "in-progress")?.pipe(takeUntil(this.destroy$)).subscribe();
    this.svgRegistry.loadSvg("../../assets/img/not-started.svg", "not-started")?.pipe(takeUntil(this.destroy$)).subscribe();
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
